import React from "react";
import image1 from "../../../assets/images/CompanyLogo/follow.webp";
import image2 from "../../../assets/images/CompanyLogo/viewUpdates.svg";
import bg2 from "../../../assets/images/CompanyLogo/bg2.webp";
import arrowright from "../../../assets/icons/arrowrightwhite.svg";
import { AiOutlineArrowRight } from 'react-icons/ai';
import TorchEffect from "../../torchEffect/TorchEffect";

const StayUpdated = () => {
  return (
    <TorchEffect style={{backgroundColor: "rgba(0,0,0,0.4)", width:"100%"}} autoHeight={true}>
    <div className="w-full flex flex-col p-2 lg:flex-rowsm:px-8 md:px-16 lg:px-32 py-auto md:py-28 justify-center lg:justify-center items-center overflow-hidden h-[450px]"
    // style={{
    //   background: `url(${bg2}) no-repeat center center / cover`,
    //   height: '700px', 
    // }}
    >
      <div className="md:py-0 max-w-[1200px] sm:flex mx-auto">
        <div className="sm:w-[40%] flex md:py-16 flex-col text-center items-center sm:items-start sm:px-4 md:px-0">
          <h1 className="max-w-[1200px] p-2 sm:p-0 text-f24 sm:text-left md:mt-2 md:text-[2rem] font-bold text-[#EBF0F3] ">
          Stay informed and manage changes proactively
          </h1>
          <h6 className="md:max-w-[503px] max-w-[343px] sm:p-0 text-center text-f14 text-normal sm:text-left md:text-[1rem] text-[#EBF0F3] md:mt-[24px]">
          Follow businesses you are interested in and receive updates when there are changes in their information. Maintain a competitive edge in navigating the ever-changing business environment.
          </h6>
        </div>
        <div className="mx-auto relative justify-center p-4 py-4 sm:w-[60%] flex md:justify-end items-center">
          <div className="relative">
            <img
              src={image1}
              alt="Background Image"
              className="w-[293px] md:-mr-[120px] md:w-[600px] md:h-[400px] sm:w-[400px] sm:h-[300px] flex-shrink-0 rounded-8"
            />
            <img
              src={image2}
              alt="Overlay Image"
              className="w-[114px] top-[50%] left-[-5%] absolute lg:left-[-15%] md:top-[40%] sm:left-[-5%] sm:top-[35%] md:w-[236px] md:h-[150px] sm:w-[200px] sm:h-[100px] flex-shrink-0 rounded-8"
            />
          </div>
        </div>
      </div>
    </div>
    </TorchEffect>
  );
};

export default StayUpdated;